import * as ambassadorWixBlogV3Draft from './blog-v3-draft-draft-posts.http.js';
import * as ambassadorWixBlogV3DraftTypes from './blog-v3-draft-draft-posts.types.js';
import * as ambassadorWixBlogV3DraftUniversalTypes from './blog-v3-draft-draft-posts.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createDraftPost(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBlogV3DraftUniversalTypes.CreateDraftPostRequest,
  ambassadorWixBlogV3DraftTypes.CreateDraftPostRequest,
  ambassadorWixBlogV3DraftUniversalTypes.CreateDraftPostResponse,
  ambassadorWixBlogV3DraftTypes.CreateDraftPostResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixBlogV3Draft.createDraftPost(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-posts',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateDraftPosts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBlogV3DraftUniversalTypes.BulkCreateDraftPostsRequest,
  ambassadorWixBlogV3DraftTypes.BulkCreateDraftPostsRequest,
  ambassadorWixBlogV3DraftUniversalTypes.BulkCreateDraftPostsResponse,
  ambassadorWixBlogV3DraftTypes.BulkCreateDraftPostsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBlogV3Draft.bulkCreateDraftPosts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/draft-posts/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateDraftPosts(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixBlogV3DraftUniversalTypes.BulkUpdateDraftPostsRequest,
  ambassadorWixBlogV3DraftTypes.BulkUpdateDraftPostsRequest,
  ambassadorWixBlogV3DraftUniversalTypes.BulkUpdateDraftPostsResponse,
  ambassadorWixBlogV3DraftTypes.BulkUpdateDraftPostsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBlogV3Draft.bulkUpdateDraftPosts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/draft-posts/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDeletedDraftPosts(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBlogV3DraftUniversalTypes.ListDeletedDraftPostsRequest,
  ambassadorWixBlogV3DraftTypes.ListDeletedDraftPostsRequest,
  ambassadorWixBlogV3DraftUniversalTypes.ListDeletedDraftPostsResponse,
  ambassadorWixBlogV3DraftTypes.ListDeletedDraftPostsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBlogV3Draft.listDeletedDraftPosts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/draft-posts/trash-bin',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDraftPost(): __PublicMethodMetaInfo<
  'GET',
  { draftPostId: string },
  ambassadorWixBlogV3DraftUniversalTypes.GetDraftPostRequest,
  ambassadorWixBlogV3DraftTypes.GetDraftPostRequest,
  ambassadorWixBlogV3DraftUniversalTypes.GetDraftPostResponse,
  ambassadorWixBlogV3DraftTypes.GetDraftPostResponse
> {
  const payload = { draftPostId: ':draftPostId' } as any;

  const getRequestOptions = ambassadorWixBlogV3Draft.getDraftPost(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/draft-posts/{draftPostId}',
    pathParams: { draftPostId: 'draftPostId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateDraftPost(): __PublicMethodMetaInfo<
  'PATCH',
  { draftPostId: string },
  ambassadorWixBlogV3DraftUniversalTypes.UpdateDraftPostRequest,
  ambassadorWixBlogV3DraftTypes.UpdateDraftPostRequest,
  ambassadorWixBlogV3DraftUniversalTypes.UpdateDraftPostResponse,
  ambassadorWixBlogV3DraftTypes.UpdateDraftPostResponse
> {
  const payload = { draftPost: { id: ':draftPostId' } } as any;

  const getRequestOptions = ambassadorWixBlogV3Draft.updateDraftPost(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/draft-posts/{draftPost.id}',
    pathParams: { draftPostId: 'draftPostId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteDraftPost(): __PublicMethodMetaInfo<
  'DELETE',
  { draftPostId: string },
  ambassadorWixBlogV3DraftUniversalTypes.DeleteDraftPostRequest,
  ambassadorWixBlogV3DraftTypes.DeleteDraftPostRequest,
  ambassadorWixBlogV3DraftUniversalTypes.DeleteDraftPostResponse,
  ambassadorWixBlogV3DraftTypes.DeleteDraftPostResponse
> {
  const payload = { draftPostId: ':draftPostId' } as any;

  const getRequestOptions = ambassadorWixBlogV3Draft.deleteDraftPost(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/draft-posts/{draftPostId}',
    pathParams: { draftPostId: 'draftPostId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeFromTrashBin(): __PublicMethodMetaInfo<
  'DELETE',
  { draftPostId: string },
  ambassadorWixBlogV3DraftUniversalTypes.RemoveFromTrashBinRequest,
  ambassadorWixBlogV3DraftTypes.RemoveFromTrashBinRequest,
  ambassadorWixBlogV3DraftUniversalTypes.RemoveFromTrashBinResponse,
  ambassadorWixBlogV3DraftTypes.RemoveFromTrashBinResponse
> {
  const payload = { draftPostId: ':draftPostId' } as any;

  const getRequestOptions =
    ambassadorWixBlogV3Draft.removeFromTrashBin(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/draft-posts/trash-bin/{draftPostId}',
    pathParams: { draftPostId: 'draftPostId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteDraftPosts(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixBlogV3DraftUniversalTypes.BulkDeleteDraftPostsRequest,
  ambassadorWixBlogV3DraftTypes.BulkDeleteDraftPostsRequest,
  ambassadorWixBlogV3DraftUniversalTypes.BulkDeleteDraftPostsResponse,
  ambassadorWixBlogV3DraftTypes.BulkDeleteDraftPostsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBlogV3Draft.bulkDeleteDraftPosts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/bulk/draft-posts',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDraftPosts(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBlogV3DraftUniversalTypes.ListDraftPostsRequest,
  ambassadorWixBlogV3DraftTypes.ListDraftPostsRequest,
  ambassadorWixBlogV3DraftUniversalTypes.ListDraftPostsResponse,
  ambassadorWixBlogV3DraftTypes.ListDraftPostsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixBlogV3Draft.listDraftPosts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/draft-posts',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDeletedDraftPost(): __PublicMethodMetaInfo<
  'GET',
  { draftPostId: string },
  ambassadorWixBlogV3DraftUniversalTypes.GetDeletedDraftPostRequest,
  ambassadorWixBlogV3DraftTypes.GetDeletedDraftPostRequest,
  ambassadorWixBlogV3DraftUniversalTypes.GetDeletedDraftPostResponse,
  ambassadorWixBlogV3DraftTypes.GetDeletedDraftPostResponse
> {
  const payload = { draftPostId: ':draftPostId' } as any;

  const getRequestOptions =
    ambassadorWixBlogV3Draft.getDeletedDraftPost(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/draft-posts/trash-bin/{draftPostId}',
    pathParams: { draftPostId: 'draftPostId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function restoreFromTrashBin(): __PublicMethodMetaInfo<
  'POST',
  { draftPostId: string },
  ambassadorWixBlogV3DraftUniversalTypes.RestoreFromTrashBinRequest,
  ambassadorWixBlogV3DraftTypes.RestoreFromTrashBinRequest,
  ambassadorWixBlogV3DraftUniversalTypes.RestoreFromTrashBinResponse,
  ambassadorWixBlogV3DraftTypes.RestoreFromTrashBinResponse
> {
  const payload = { draftPostId: ':draftPostId' } as any;

  const getRequestOptions =
    ambassadorWixBlogV3Draft.restoreFromTrashBin(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-posts/trash-bin/{draftPostId}/restore',
    pathParams: { draftPostId: 'draftPostId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryDraftPosts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBlogV3DraftUniversalTypes.QueryDraftPostsRequest,
  ambassadorWixBlogV3DraftTypes.QueryDraftPostsRequest,
  ambassadorWixBlogV3DraftUniversalTypes.QueryDraftPostsResponse,
  ambassadorWixBlogV3DraftTypes.QueryDraftPostsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixBlogV3Draft.queryDraftPosts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-posts/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function publishDraftPost(): __PublicMethodMetaInfo<
  'POST',
  { draftPostId: string },
  ambassadorWixBlogV3DraftUniversalTypes.PublishDraftPostRequest,
  ambassadorWixBlogV3DraftTypes.PublishDraftPostRequest,
  ambassadorWixBlogV3DraftUniversalTypes.PublishDraftPostResponse,
  ambassadorWixBlogV3DraftTypes.PublishDraftPostResponse
> {
  const payload = { draftPostId: ':draftPostId' } as any;

  const getRequestOptions = ambassadorWixBlogV3Draft.publishDraftPost(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-posts/{draftPostId}/publish',
    pathParams: { draftPostId: 'draftPostId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  DraftPost as DraftPostOriginal,
  Image as ImageOriginal,
  FocalPoint as FocalPointOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  Background as BackgroundOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  Rel as RelOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  V1Media as V1MediaOriginal,
  ItemImage as ItemImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Option as OptionOriginal,
  PollSettings as PollSettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  CardStylesType as CardStylesTypeOriginal,
  CardStylesTypeWithLiterals as CardStylesTypeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  Dimensions as DimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  BannerOrigin as BannerOriginOriginal,
  BannerOriginWithLiterals as BannerOriginWithLiteralsOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  Banner as BannerOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  Backdrop as BackdropOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  SmartBlockData as SmartBlockDataOriginal,
  SmartBlockDataType as SmartBlockDataTypeOriginal,
  SmartBlockDataTypeWithLiterals as SmartBlockDataTypeWithLiteralsOriginal,
  ColumnSize as ColumnSizeOriginal,
  ColumnSizeWithLiterals as ColumnSizeWithLiteralsOriginal,
  SmartBlockCellData as SmartBlockCellDataOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  ModerationDetails as ModerationDetailsOriginal,
  ModerationStatusStatus as ModerationStatusStatusOriginal,
  ModerationStatusStatusWithLiterals as ModerationStatusStatusWithLiteralsOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  PageUrl as PageUrlOriginal,
  Media as MediaOriginal,
  MediaMediaOneOf as MediaMediaOneOfOriginal,
  WixMedia as WixMediaOriginal,
  VideoV2 as VideoV2Original,
  VideoResolution as VideoResolutionOriginal,
  EmbedMedia as EmbedMediaOriginal,
  EmbedThumbnail as EmbedThumbnailOriginal,
  EmbedVideo as EmbedVideoOriginal,
  DraftPostTranslation as DraftPostTranslationOriginal,
  DraftCategoriesUpdated as DraftCategoriesUpdatedOriginal,
  DraftTagsUpdated as DraftTagsUpdatedOriginal,
  GetDraftPostTotalsRequest as GetDraftPostTotalsRequestOriginal,
  TotalDraftPostsGroupingField as TotalDraftPostsGroupingFieldOriginal,
  TotalDraftPostsGroupingFieldWithLiterals as TotalDraftPostsGroupingFieldWithLiteralsOriginal,
  GetDraftPostTotalsResponse as GetDraftPostTotalsResponseOriginal,
  TotalDraftPosts as TotalDraftPostsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  InitialDraftPostsCopied as InitialDraftPostsCopiedOriginal,
  CreateDraftPostRequest as CreateDraftPostRequestOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Field as FieldOriginal,
  FieldWithLiterals as FieldWithLiteralsOriginal,
  CreateDraftPostResponse as CreateDraftPostResponseOriginal,
  BulkCreateDraftPostsRequest as BulkCreateDraftPostsRequestOriginal,
  BulkCreateDraftPostsResponse as BulkCreateDraftPostsResponseOriginal,
  BulkDraftPostResult as BulkDraftPostResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateDraftPostsRequest as BulkUpdateDraftPostsRequestOriginal,
  MaskedDraftPosts as MaskedDraftPostsOriginal,
  Action as ActionOriginal,
  ActionWithLiterals as ActionWithLiteralsOriginal,
  BulkUpdateDraftPostsResponse as BulkUpdateDraftPostsResponseOriginal,
  DraftPostOwnerChanged as DraftPostOwnerChangedOriginal,
  ListDeletedDraftPostsRequest as ListDeletedDraftPostsRequestOriginal,
  GetDraftPostsSort as GetDraftPostsSortOriginal,
  GetDraftPostsSortWithLiterals as GetDraftPostsSortWithLiteralsOriginal,
  BlogPaging as BlogPagingOriginal,
  ListDeletedDraftPostsResponse as ListDeletedDraftPostsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  GetDraftPostRequest as GetDraftPostRequestOriginal,
  GetDraftPostResponse as GetDraftPostResponseOriginal,
  UpdateDraftPostContentRequest as UpdateDraftPostContentRequestOriginal,
  UpdateDraftPostContentResponse as UpdateDraftPostContentResponseOriginal,
  UpdateDraftPostRequest as UpdateDraftPostRequestOriginal,
  UpdateDraftPostResponse as UpdateDraftPostResponseOriginal,
  DeleteDraftPostRequest as DeleteDraftPostRequestOriginal,
  DeleteDraftPostResponse as DeleteDraftPostResponseOriginal,
  RemoveFromTrashBinRequest as RemoveFromTrashBinRequestOriginal,
  RemoveFromTrashBinResponse as RemoveFromTrashBinResponseOriginal,
  BulkDeleteDraftPostsRequest as BulkDeleteDraftPostsRequestOriginal,
  BulkDeleteDraftPostsResponse as BulkDeleteDraftPostsResponseOriginal,
  ListDraftPostsRequest as ListDraftPostsRequestOriginal,
  ListDraftPostsResponse as ListDraftPostsResponseOriginal,
  MetaData as MetaDataOriginal,
  GetDeletedDraftPostRequest as GetDeletedDraftPostRequestOriginal,
  GetDeletedDraftPostResponse as GetDeletedDraftPostResponseOriginal,
  RestoreFromTrashBinRequest as RestoreFromTrashBinRequestOriginal,
  RestoreFromTrashBinResponse as RestoreFromTrashBinResponseOriginal,
  QueryDraftPostsRequest as QueryDraftPostsRequestOriginal,
  PlatformQuery as PlatformQueryOriginal,
  PlatformQueryPagingMethodOneOf as PlatformQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryDraftPostsResponse as QueryDraftPostsResponseOriginal,
  PublishDraftPostRequest as PublishDraftPostRequestOriginal,
  PublishDraftPostResponse as PublishDraftPostResponseOriginal,
  UnpublishPostRequest as UnpublishPostRequestOriginal,
  UnpublishPostResponse as UnpublishPostResponseOriginal,
  GetDraftPostCountsRequest as GetDraftPostCountsRequestOriginal,
  GetDraftPostCountsResponse as GetDraftPostCountsResponseOriginal,
  DraftPostCount as DraftPostCountOriginal,
  TranslateDraftRequest as TranslateDraftRequestOriginal,
  TranslateDraftResponse as TranslateDraftResponseOriginal,
  IsDraftPostAutoTranslatableRequest as IsDraftPostAutoTranslatableRequestOriginal,
  IsDraftPostAutoTranslatableResponse as IsDraftPostAutoTranslatableResponseOriginal,
  UpdateDraftPostLanguageRequest as UpdateDraftPostLanguageRequestOriginal,
  UpdateDraftPostLanguageResponse as UpdateDraftPostLanguageResponseOriginal,
  BulkRevertToUnpublishedRequest as BulkRevertToUnpublishedRequestOriginal,
  BulkRevertToUnpublishedResponse as BulkRevertToUnpublishedResponseOriginal,
  BulkRejectDraftPostRequest as BulkRejectDraftPostRequestOriginal,
  BulkRejectDraftPostResponse as BulkRejectDraftPostResponseOriginal,
  RevertToUnpublishedRequest as RevertToUnpublishedRequestOriginal,
  RevertToUnpublishedResponse as RevertToUnpublishedResponseOriginal,
  RejectDraftPostRequest as RejectDraftPostRequestOriginal,
  RejectDraftPostResponse as RejectDraftPostResponseOriginal,
  ApproveDraftPostRequest as ApproveDraftPostRequestOriginal,
  ApproveDraftPostResponse as ApproveDraftPostResponseOriginal,
  MarkPostAsInModerationRequest as MarkPostAsInModerationRequestOriginal,
  MarkPostAsInModerationResponse as MarkPostAsInModerationResponseOriginal,
} from './blog-v3-draft-draft-posts.types.js';
